<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Folio</th>
            <th :class="StyleTh">Fecha Timbrado</th>
            <th :class="StyleTh">UUID</th>
            <th :class="StyleTh">Estatus Cancel</th>
            
            <th :class="StyleTh+' text-center'">*</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td><h6 :class="StylePr">{{lista.Serie+'-'+lista.Folio}}</h6></td>
                <td>
                    <p :class="StyleTd">{{lista.IdUsuario}}</p>
                </td>
                <td>
                    <p :class="StyleTd">{{lista.IdUsuario}}</p>
                </td>
                <td>
                    <p :class="StyleTd">{{lista.NombreCliente}}</p>
                </td>
                
                <td class="align-middle text-end">
                    <template v-if="UUIDCliente != lista.UUID">
                        <button @click="SeleccionarNota(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary"></i> Agregar</button>
                    </template>
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
        </template>
    </CList>
</template>

<script>

import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionRelacionadas';

export default {
    name: 'ListaFacturasRelacionadas',
    props: ['poBtnSave'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: '',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                BtnNewShow: false,
                TitleFirst: '',
                ShowTitleFirst: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            Emit: this.poBtnSave.EmitSeccion,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ListaAgregados: [],
            IdCliente: 0,
            UUIDCliente: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("getNotasRelacionadas",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdCliente: this.IdCliente,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        SeleccionarNota(item)
        {
            let obj = {
                IdNotaPago: item.IdNotaPago,
                UUID: '12345-678910',//item.UUID,
            };

            this.bus.$emit('AgregarNotalRel',obj);
            this.bus.$emit('CloseModal_'+this.Emit);
        },
        GetVisible(item)
        {
            let Buscar = 12345//item.UUID;
            let Valor = true;
            let Search = this.ListaAgregados.filter(function(element){
                if(element.UUID == Buscar){
                    return element;
                }
            });

            if(Search[0]){
                Valor = false;
            }

            return Valor;
        },
    },
    created()
    {
        this.bus.$off('List_'+EmitEjecuta);

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.IdCliente = obj.IdCliente;
            this.UUIDCliente = obj.UUID;

            this.Lista();
        });
    },
    mounted()
    {
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });
    }
}
</script>